import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Employees } from '../../../interfaces/employees';
import { Users } from 'src/app/models/interfaces/users';
import { Helps } from 'src/app/libs/helps';

@Component({
  selector: 'app-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.css']
})
export class ListUsersComponent implements OnInit, OnChanges {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private router: Router,
    private helps:Helps
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['storesId'].currentValue!=this.storesId){
      this.get();
    }
  }
  level:number=0;
  view: number = 1;
  status: any;
  selected?: Users;
  ngOnInit(): void {
    this.get();
    this.level=this.helps.getToken()?.level??0;
  }
  @Input()
  storesId: number;

  items: Users[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  secondForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });
  delete() {
    this.secondForm.get('id')?.setValue(this.selected?.id);
    this.api.deleteUsers(this.secondForm).subscribe(
      (res) => {
        this.toast.success('Usuario eliminado correctamente', 'USUARIOS');
        this.get();
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  get() {
    this.api.paginateUsers(this.page,this.storesId).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Users[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;

        this.totalPage = data.total;
      },
      (error) => {
        this.items = null;
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
        this.toast;
      }
    );
  }
  openModal(md:any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openDelete(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openEdit(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  search() {
    this.get();
  }
  clean() {}
}

